import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-6.5,0.5h1v0.5h-1zM6,0.5h0.5v0.5h-0.5zM-3.5,1h4.5v0.5h-4.5z' },
    {
      paint: 'rock',
      d: 'M4.5,-10.5h0.5v1h-0.5zM5,-9.5h0.5v1h-0.5zM5,-8.5h1v1h-1zM3,-8h1v0.5h-1zM3,-7.5h3v0.5h-3zM3,-7h3.5v0.5h-3.5zM2.5,-6.5h4v2.5h-4zM-1,-4h0.5v0.5h-0.5zM3.5,-4h3v0.5h-3zM-1.5,-3.5h1v0.5h-1zM4,-3.5h3v1h-3zM-2,-3h1.5v0.5h-1.5zM-2.5,-2.5h2v0.5h-2zM2.5,-2.5h4.5v1h-4.5zM-2,-2h1.5v1h-1.5zM3,-1.5h1.5v2h-1.5zM5.5,-1.5h1.5v0.5h-1.5zM-1.5,-1h1.5v1h-1.5zM6.5,-1h0.5v0.5h-0.5zM-1,0h1v1h-1zM3,0.5h2.5v0.5h-2.5zM1,1h2.5v0.5h-2.5z',
    },
    {
      paint: 'boulder',
      d: 'M1,-12h0.5v1h-0.5zM2,-12h0.5v0.5h-0.5zM3.5,-11.5h0.5v0.5h-0.5zM0.5,-11h1v0.5h-1zM0.5,-10.5h1.5v1h-1.5zM0.5,-9.5h2v1h-2zM4.5,-9.5h0.5v0.5h-0.5zM0,-8.5h3v2h-3zM-2,-7.5h0.5v0.5h-0.5zM-3,-7h0.5v0.5h-0.5zM-4,-6.5h0.5v0.5h-0.5zM0,-6.5h2.5v0.5h-2.5zM-1,-6h3.5v0.5h-3.5zM-5.5,-5.5h1v1h-1zM-0.5,-5.5h3v1.5h-3zM-5.5,-4.5h1.5v0.5h-1.5zM-6,-4h2.5v0.5h-2.5zM-0.5,-4h3.5v0.5h-3.5zM-6,-3.5h3v1h-3zM-0.5,-3.5h3v2h-3zM-6,-2.5h3.5v0.5h-3.5zM-6.5,-2h1.5v0.5h-1.5zM-4,-2h2v1h-2zM-6.5,-1.5h1v0.5h-1zM-0.5,-1.5h3.5v0.5h-3.5zM-6.5,-1h0.5v0.5h-0.5zM-3.5,-1h2v1h-2zM0,-1h3v2h-3zM-7,-0.5h0.5v1h-0.5zM6.5,-0.5h0.5v0.5h-0.5zM-1.5,0h0.5v0.5h-0.5zM-2,0.5h1v0.5h-1z',
    },
    {
      paint: 'cobble',
      d: 'M1.5,-12h0.5v0.5h-0.5zM1.5,-11.5h2v0.5h-2zM1.5,-11h3v0.5h-3zM2,-10.5h2.5v1h-2.5zM2.5,-9.5h2v0.5h-2zM2.5,-9h2.5v0.5h-2.5zM3,-8.5h2v0.5h-2zM4,-8h1v0.5h-1zM-2.5,-7h1.5v0.5h-1.5zM-3.5,-6.5h2.5v0.5h-2.5zM-5,-6h4v0.5h-4zM-4.5,-5.5h4v1h-4zM-4,-4.5h3.5v0.5h-3.5zM-3.5,-4h2.5v0.5h-2.5zM-3,-3.5h1.5v0.5h-1.5zM-3,-3h1v0.5h-1z',
    },
    {
      paint: 'moss',
      d: 'M3,-4h0.5v0.5h-0.5zM2.5,-3.5h1.5v1h-1.5zM-5.5,-1.5h0.5v0.5h-0.5zM-6,-1h1v0.5h-1zM-4,-1h0.5v0.5h-0.5zM5.5,-1h1v1h-1zM-6.5,-0.5h1.5v0.5h-1.5zM-4.5,-0.5h1v0.5h-1zM-6.5,0h5v0.5h-5zM5,0h1.5v0.5h-1.5zM-5.5,0.5h3.5v0.5h-3.5zM5.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'tallGrass',
      d: 'M-5,-2h1v1.5h-1zM4.5,-1.5h1v1.5h-1zM-5,-0.5h0.5v0.5h-0.5zM4.5,0h0.5v0.5h-0.5zM6.5,0h0.5v0.5h-0.5z',
    },
  ],
  pixels: 503,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'shadow',
      d: 'M-6.5,0.5h1v0.5h-1zM6,0.5h0.5v0.5h-0.5zM-3,1h4.5v0.5h-4.5zM3,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'rock',
      d: 'M5,-6.5h0.5v0.5h-0.5zM4.5,-6h1v0.5h-1zM4,-5.5h1v0.5h-1zM1.5,-5h3.5v0.5h-3.5zM1,-4.5h4v1h-4zM-2,-3.5h0.5v1h-0.5zM1,-3.5h3.5v0.5h-3.5zM1,-3h2v0.5h-2zM-4.5,-2.5h0.5v0.5h-0.5zM-2.5,-2.5h0.5v0.5h-0.5zM-1.5,-2.5h0.5v0.5h-0.5zM0.5,-2.5h0.5v0.5h-0.5zM-4.5,-2h2.5v2h-2.5zM6,-1.5h1v0.5h-1zM5,-1h1.5v1.5h-1.5zM-4.5,0h1.5v0.5h-1.5zM-5.5,0.5h2.5v0.5h-2.5zM4.5,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'boulder',
      d: 'M-1,-7h0.5v1h-0.5zM-1,-6h1.5v0.5h-1.5zM-1.5,-5.5h3v1h-3zM-4,-5h0.5v0.5h-0.5zM-1.5,-4.5h2.5v2h-2.5zM-6.5,-3.5h0.5v0.5h-0.5zM-7,-3h1.5v0.5h-1.5zM-7,-2.5h2.5v3h-2.5zM-4,-2.5h1v0.5h-1zM-0.5,-2.5h1v0.5h-1zM1,-2.5h0.5v0.5h-0.5zM-1,-2h2v0.5h-2zM-1,-1.5h3v0.5h-3zM5.5,-1.5h0.5v0.5h-0.5zM-1,-1h3.5v1h-3.5zM4.5,-1h0.5v0.5h-0.5zM-3,0h0.5v0.5h-0.5zM-0.5,0h3v1h-3zM4,0.5h0.5v0.5h-0.5zM-3.5,1h0.5v0.5h-0.5zM1.5,1h1.5v0.5h-1.5z',
    },
    {
      paint: 'cobble',
      d: 'M1.5,-8h1v0.5h-1zM0,-7.5h3v0.5h-3zM1.5,-7h1.5v1h-1.5zM4,-7h0.5v0.5h-0.5zM4,-6.5h1v0.5h-1zM1.5,-6h3v0.5h-3zM1.5,-5.5h2.5v0.5h-2.5zM-3.5,-5h1v0.5h-1zM-5,-4.5h3.5v0.5h-3.5zM-6.5,-4h0.5v0.5h-0.5zM-4,-4h2.5v0.5h-2.5zM-3.5,-3.5h1.5v0.5h-1.5zM-4,-3h2v0.5h-2zM3,-3h2.5v0.5h-2.5zM-3,-2.5h0.5v0.5h-0.5zM1.5,-2.5h4.5v0.5h-4.5zM1,-2h5.5v0.5h-5.5zM2,-1.5h3.5v0.5h-3.5z',
    },
    {
      paint: 'moss',
      d: 'M-0.5,-7h2v1h-2zM0.5,-6h1v0.5h-1zM-6,-4h2v0.5h-2zM-6,-3.5h2.5v0.5h-2.5zM-5.5,-3h1.5v0.5h-1.5zM2.5,-1h2v0.5h-2zM2.5,-0.5h2.5v1h-2.5zM-2.5,0h2v0.5h-2zM-3,0.5h2.5v0.5h-2.5zM2.5,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'tallGrass',
      d: 'M2.5,-8.5h0.5v0.5h-0.5zM2.5,-8h1.5v0.5h-1.5zM3,-7.5h1v1.5h-1zM-2,-2.5h0.5v0.5h-0.5zM-1,-2.5h0.5v0.5h-0.5zM-2,-2h1v2h-1z',
    },
  ],
  pixels: 372,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'shadow',
      d: 'M-2.5,-0.5h5.5v0.5h-5.5zM-2.5,0h6v0.5h-6zM6,0h0.5v1h-0.5zM-3.5,0.5h7v1h-7z',
    },
    {
      paint: 'rock',
      d: 'M1,-10h1v0.5h-1zM1.5,-9.5h1.5v0.5h-1.5zM1.5,-9h2v0.5h-2zM2,-8.5h2.5v0.5h-2.5zM2,-8h1.5v0.5h-1.5zM-3,-6.5h1v1h-1zM5,-6h0.5v0.5h-0.5zM-3,-5.5h1.5v0.5h-1.5zM4,-5.5h1.5v0.5h-1.5zM-3.5,-5h1.5v1h-1.5zM4.5,-5h1v0.5h-1zM4.5,-4.5h1.5v1.5h-1.5zM-3.5,-4h1v4.5h-1zM5,-3h1.5v1h-1.5zM5,-2h2v1h-2zM5.5,-1h1v1h-1z',
    },
    {
      paint: 'boulder',
      d: 'M-1,-10.5h0.5v0.5h-0.5zM0.5,-10.5h0.5v0.5h-0.5zM-4.5,-9.5h0.5v0.5h-0.5zM-5,-8.5h0.5v0.5h-0.5zM-5.5,-7h3v0.5h-3zM1.5,-7h1.5v0.5h-1.5zM-6,-6.5h3v1.5h-3zM1,-6.5h2.5v0.5h-2.5zM0,-6h4v0.5h-4zM1,-5.5h3v0.5h-3zM-6,-5h2.5v2h-2.5zM1.5,-5h3v0.5h-3zM2,-4.5h2.5v0.5h-2.5zM2.5,-4h2v1h-2zM-6.5,-3h3v1h-3zM2.5,-3h2.5v1h-2.5zM-6.5,-2h2v0.5h-2zM-4,-2h0.5v3h-0.5zM3,-2h2v1h-2zM-6.5,-1.5h1.5v0.5h-1.5zM-6.5,-1h0.5v1h-0.5zM3,-1h1v0.5h-1zM3,-0.5h0.5v0.5h-0.5zM5.5,0h0.5v1h-0.5zM3.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'cobble',
      d: 'M-0.5,-10.5h1v0.5h-1zM-4,-10h1v0.5h-1zM-2,-10h3v0.5h-3zM-4,-9.5h0.5v0.5h-0.5zM-1.5,-9.5h3v1h-3zM-4.5,-9h1v0.5h-1zM-4.5,-8.5h6.5v0.5h-6.5zM-5,-8h7v0.5h-7zM3.5,-8h1v0.5h-1zM-5.5,-7.5h10v0.5h-10zM-2.5,-7h4v0.5h-4zM3,-7h2v0.5h-2zM-2,-6.5h3v0.5h-3zM3.5,-6.5h1.5v0.5h-1.5zM-2,-6h2v0.5h-2zM4,-6h1v0.5h-1z',
    },
    {
      paint: 'moss',
      d: 'M-3,-10h1v0.5h-1zM-3.5,-9.5h2v1h-2zM-6,-1h1v1h-1zM3.5,-0.5h1v1h-1zM5,-0.5h0.5v1h-0.5zM-6.5,0h2.5v1h-2.5zM4,0.5h1.5v0.5h-1.5zM-5.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'tallGrass',
      d: 'M-4.5,-2h0.5v0.5h-0.5zM-5,-1.5h1v1.5h-1zM4,-1h1.5v0.5h-1.5zM4.5,-0.5h0.5v1h-0.5z',
    },
  ],
  pixels: 421,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
